// extracted by mini-css-extract-plugin
export default {"inputAnswer":"InputQuestion_inputAnswer__6ZQwH","question":"InputQuestion_question__FfJlL","questionStrong":"InputQuestion_questionStrong__K8GQ3"};